import { Trans } from '@lingui/react'
import type { FC } from 'react'
import type { MenuProvided } from 'react-instantsearch-core'
import { connectSortBy } from 'react-instantsearch-dom'

import store from 'shared/store'
import { hideModalAction } from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import InputCheckboxOrRadio from 'views/components/molecules/InputCheckboxOrRadio'
import { interact } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'

import './SortByMobileV1.scss'

const renderOptions = ({
  items,
  refine,
  currentRefinement,
  modalId,
}: {
  items: MenuProvided['items']
  refine: MenuProvided['refine']
  currentRefinement: MenuProvided['currentRefinement']
  modalId: string
}) => {
  return items.map(item => {
    const key = item.value

    return (
      <li role="menuitem" key={key} className="o-SortByMobileV1__menu-item">
        <InputCheckboxOrRadio
          type="radio"
          value={item.value}
          checked={currentRefinement === item.value}
          // @ts-ignore
          onChange={event => {
            interact(refine, key)(event)
            store.dispatch(hideModalAction(modalId))
          }}
        >
          {item.label}
        </InputCheckboxOrRadio>
      </li>
    )
  })
}

type SortByMobileV1Type = MenuProvided & {
  modalId: string
}

const SortByMobileV1: FC<SortByMobileV1Type> = ({
  items,
  refine,
  currentRefinement,
  modalId,
}) => {
  return (
    <div className="o-SortByMobileV1">
      <ul className="o-SortByMobileV1__list a-list-reset">
        {renderOptions({
          items,
          refine,
          currentRefinement,
          modalId,
        })}
        <li className="o-SortByMobileV1__menu-item">
          <Button
            className="o-SortByMobileV1__close-button"
            data-a11y-dialog-hide
            style="buttonSecondary"
          >
            <Trans id="general.link.label.close" />
          </Button>
        </li>
      </ul>
    </div>
  )
}

export default connectSortBy(SortByMobileV1)
